import React from 'react';
import { motion } from 'framer-motion';

export const Shapes = ({ isHover, isPress, mouseX, mouseY }) => {
  const variants = {
    default: { scale: 0.8 },
    hover: { scale: 1 },
    press: { scale: 0.9 }
  };

  return (
    <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 }}>
      <motion.div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          width: 100,
          height: 100,
          borderRadius: 20,
          backgroundColor: 'rgba(255, 0, 0, 0.5)',
          x: mouseX,
          y: mouseY
        }}
        variants={variants}
        animate={isPress ? "press" : isHover ? "hover" : "default"}
      />
      <motion.div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          width: 100,
          height: 100,
          borderRadius: '50%',
          backgroundColor: 'rgba(0, 0, 255, 0.5)',
          x: mouseX,
          y: mouseY
        }}
        variants={variants}
        animate={isPress ? "press" : isHover ? "hover" : "default"}
      />
    </div>
  );
};

export default Shapes; 